module.exports = __webpack_public_path__ + "img/GPG photo 4.f3ea4fe6.png";